import { useCallback } from 'react'
import DrkTrimMainLogo from '@/components/svg/DrkTrimMain'
import Button from '@/components/Button'
import { useCountdown } from '@/hooks/useCountdown'

const COUNTDOWN_SECONDS = 5

export const ChunkErrorFallback = () => {
  const seconds = useCountdown(COUNTDOWN_SECONDS)

  if (seconds <= 0) {
    window.location.reload()
  }

  const handleRefresh = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-primary'>
      <main className='mx-lg w-full max-w-xl rounded-[15px] bg-secondary px-3xl py-xl shadow-2xl'>
        <DrkTrimMainLogo
          className='mb-3xl'
          role='img'
          aria-label='MyAssetMap Logo'
        />

        <h1 className='mb-sm text-lg font-semibold text-white/80'>
          A new version of MyAssetMap is now available
        </h1>

        <p className='mb-sm text-xs leading-relaxed text-white/80'>
          To begin, please refresh your browser window.
        </p>

        <p className='mb-xl text-xs text-white/80'>
          This page will automatically refresh in{' '}
          <span className='font-semibold text-white'>{seconds}</span> second
          {seconds !== 1 ? 's' : ''}.
        </p>

        <Button
          variant='primary'
          size='md'
          label='Refresh Now'
          onClick={handleRefresh}
          aria-label='Refresh the page to load the new version'
        />
      </main>
    </div>
  )
}

export default ChunkErrorFallback
